import { lazy } from 'react';
const rebondver = lazy(() => import('./rebondver'));

const rebondverRoutes = [
  {
    path: '/rebondver',
    component: rebondver
  }
];

export default rebondverRoutes;
